import { IState } from '../data-types'

const getNMOPoints = (state: IState): string => state.nmo.NMOPoints
const getSource = (state: IState): string => state.nmo.source

export { getNMOPoints, getSource }
